import updateMessageLikers from '../actions/updateMessageLikers';
import likeItemService from '../services/likeItemService';
import { action, orchestrator } from 'satcheljs';
var likeItem = action('likeItem', function (itemId, tableView, isUnlike, userEmailAddress, userDisplayName, isLocalUpdateOnly) {
    return {
        itemId: itemId,
        tableView: tableView,
        isUnlike: isUnlike,
        userEmailAddress: userEmailAddress,
        userDisplayName: userDisplayName,
        isLocalUpdateOnly: isLocalUpdateOnly,
    };
});
orchestrator(likeItem, function (actionMessage) {
    var tableView = actionMessage.tableView, isUnlike = actionMessage.isUnlike, itemId = actionMessage.itemId, userEmailAddress = actionMessage.userEmailAddress, userDisplayName = actionMessage.userDisplayName;
    updateMessageLikers(itemId.Id, tableView, isUnlike, userEmailAddress, userDisplayName);
    if (!actionMessage.isLocalUpdateOnly) {
        likeItemService(itemId, isUnlike, itemId.mailboxInfo.requestOptions);
    }
});
export default likeItem;
//# sourceMappingURL=likeItem.js.map